import {
  AlignCenterHorizontal,
  AlignCenterVertical,
  AlignEndHorizontal,
  AlignEndVertical,
  AlignStartHorizontal,
  AlignStartVertical,
} from 'lucide-react'
import type { AlignToolKey } from '../types/layout-operations'
import { TooltipIconButton } from './tooltip-icon-button'

/** The six Align toolbar buttons, in on-screen order. `label` is the accessible name and tooltip. */
const ALIGN_TOOLS = [
  { key: 'top', Icon: AlignStartHorizontal, label: 'Align top edges' },
  { key: 'center', Icon: AlignCenterHorizontal, label: 'Align vertical centers' },
  { key: 'bottom', Icon: AlignEndHorizontal, label: 'Align bottom edges' },
  { key: 'left', Icon: AlignStartVertical, label: 'Align left edges' },
  { key: 'middle', Icon: AlignCenterVertical, label: 'Align horizontal centers' },
  { key: 'right', Icon: AlignEndVertical, label: 'Align right edges' },
] as const

interface AlignButtonsProps {
  disabled: boolean
  onAlign: (key: AlignToolKey) => void
}

export function AlignButtons({ disabled, onAlign }: AlignButtonsProps) {
  return (
    <div className="space-y-2">
      <label className="text-sm font-medium text-foreground leading-none">Align</label>
      <div className="grid grid-cols-3 sm:grid-cols-6 gap-1 mt-2">
        {ALIGN_TOOLS.map(({ key, Icon, label }) => (
          <TooltipIconButton
            key={key}
            tooltip={label}
            disabled={disabled}
            onClick={() => onAlign(key)}
            aria-label={label}
            className="text-muted-foreground"
          >
            <Icon className="h-4 w-4" aria-hidden />
          </TooltipIconButton>
        ))}
      </div>
    </div>
  )
}
